import React, { useEffect, useState } from 'react';

const Resource = () => {

    return (
        <div className="container d-flex justify-content-center">
            {/* <div style={{maxWidth: "700px"}} className='p-5 shadow-lg'>
                {
                    HTMLReactParser(`<p>${base?.text?.split('\n')?.join('<br />')}</p>`)
                }
            </div> */}
        </div>
    )
};

export default Resource;